/* eslint react/prop-types: 0 */
import React, { useState } from 'react'
import Switch from 'react-switch'

import { cloudhelpPatch } from 'Utilities/CloudHelp'

const Setting = ({ setting: { enabled, id }, children }) => {
  const [isSettingEnabled, setSetting] = useState(enabled)

  const handleChange = (isChecked) => {
    const setting = { enabled: isChecked }

    cloudhelpPatch(`/settings/${id}`, { setting })
      .then((response) => {
        const { data: { enabled: isEnabled } } = response

        setSetting(isEnabled)
      }).catch(error => console.log(error))
  }

  return (
    <Switch
      onChange={handleChange}
      checked={isSettingEnabled}
      onColor="#00baea"
    />
  )
}

export default Setting
